import { computed } from 'vue';
import { addDays } from 'date-fns';
import { useCookie } from '#app/composables/cookie';
import { useUserAgentState } from './useUserAgentState';

export function useAppBanner() {
  const { isFromNavel } = useUserAgentState();

  const shouldDisplayAppBanner = computed(() => {
    const appBannerClosed = useCookie('appBannerClosed');
    return !isFromNavel.value && !appBannerClosed.value;
  });

  function closeAppBanner() {
    const appBannerClosed = useCookie('appBannerClosed', {
      expires: addDays(new Date(), 1),
    });
    appBannerClosed.value = 'true';
  }

  return {
    shouldDisplayAppBanner,
    closeAppBanner,
  };
}
